import { Sparkles, RefreshCw, Lightbulb, UserCheck } from "lucide-react";

const MAP = {
  analyse: { cls: "bg-[#F0F4F1] text-[#4A6B53] border-[#D5E3D8]", label: "ANALYSE IA", Icon: Sparkles },
  adaptation: { cls: "bg-[#FFF8E7] text-[#8C6B16] border-[#F2E4C2]", label: "ADAPTATION IA", Icon: RefreshCw },
  recommandation: { cls: "bg-[#F3F4F6] text-[#4B5563] border-[#E5E7EB]", label: "RECOMMANDATION IA", Icon: Lightbulb },
  coach: { cls: "bg-[#111111] text-white border-[#111111]", label: "DÉCISION DU COACH", Icon: UserCheck },
};

export function ProvenanceBadge({ type = "analyse", children, className = "" }) {
  const m = MAP[type] || MAP.analyse;
  const Icon = m.Icon;
  return (
    <span
      data-testid={`badge-${type}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-semibold tracking-[0.14em] ${m.cls} ${className}`}
    >
      <Icon size={11} strokeWidth={2} />
      {children || m.label}
    </span>
  );
}
